import styled from '@emotion/styled';
import { N20 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var TextSkeleton = styled.div(function (props) {
  return {
    height: props.height || '16px',
    maxWidth: props.width || '269px',
    borderRadius: '3px',
    backgroundColor: props.color || "var(--ds-background-neutral, ".concat(N20, ")"),
    // TODO: https://product-fabric.atlassian.net/browse/DSP-1426

    marginBottom: props.marginBottom || '4px'
  };
});